<nav class="bg-linear-to-b from-peps-dark-700 to-transparent w-full z-50 top-0">
	<div class="season-corners" aria-hidden="true"><b></b><b></b></div>
	<div class="season-spiders" aria-hidden="true"><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span></div>


	<div class="mx-auto">

		<div class="relative flex h-20 items-center justify-between">

			<div class="absolute inset-y-0 left-0 flex items-center xl:hidden">

				<button
					type="button"
					class="relative inline-flex items-center justify-center rounded-md p-2 ml-4 cursor-pointer"
					(click)="toggleMobileMenu()"
					(keydown.enter)="toggleMobileMenu()"
					aria-controls="mobile-menu" aria-expanded="false">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-12">
						<path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
					</svg>
				</button>

			</div>

			<div class="flex flex-1 items-center justify-center xl:items-stretch xl:justify-start">
				<div class="flex shrink-0 items-center pl-2">
					<a [href]="'/'">
						<img
							ngSrc="/assets/images/team_peps_logo.avif"
							alt="Logo Team Peps"
							width="59"
							height="72"
							/>
					</a>

				</div>
				<div class="hidden xl:mx-6 xl:flex items-center justify-between w-full">
					<div class="flex items-center gap-4 text-xl">
						<peps-dropdown-button
							[text]="'component.navbar.team.title' | translate"
							route="roster/overwatch/pro"
							[items]="itemsDropdownRoster"
						></peps-dropdown-button>
						<peps-dropdown-button
							[text]="'component.navbar.club.title' | translate"
							route="club"
							[items]="itemsDropdownClub"
						></peps-dropdown-button>
						<peps-button-simple
							[text]="'common.matches.titlecase' | translate"
							route="matchs"
							(click)="toMatches()"
							(keydown.enter)="toMatches()"
						></peps-button-simple>
						<peps-button-simple
							[text]="'component.navbar.ambassadors' | translate"
							route="ambassadors"
							(click)="toAmbassadors()"
							(keydown.enter)="toAmbassadors()"
						></peps-button-simple>
						<peps-button-simple
							[text]="'common.partners' | translate"
							route="partners"
							(click)="toPartners()"
							(keydown.enter)="toPartners()"
						></peps-button-simple>
						<peps-button-simple
							[text]="'common.support-us' | translate"
							(click)="toTipee()"
							(keydown.enter)="toTipee()"
						></peps-button-simple>
						<peps-category-dropdown-button
							[text]="'component.navbar.game.title' | translate"
							[items]="itemsDropdownGames"
						></peps-category-dropdown-button>
						@if (showTicketing()) {
							<a
								[href]="ticketingUrl"
								target="_blank"
								rel="noopener noreferrer"
								class="inline-block px-6 py-3 cursor-pointer text-peps-dark-900 bg-peps-gold font-black text-nowrap uppercase tracking-wider hover:bg-peps-yellow transition-colors duration-300"
							>
								{{ "component.navbar.ticketing" | translate }}
							</a>
						}
						<a
							href="https://bundle.teampeps.fr"
							target="_blank"
							rel="noopener noreferrer"
							class="promo-explosion inline-block px-8 py-3 cursor-pointer text-peps-dark-900 bg-peps-gold font-black text-nowrap uppercase tracking-wider animate-heartbeat transition-all"						>
							{{ "component.navbar.bundle-offer" | translate }}
						</a>
					</div>
				</div>
			</div>

			<div class="absolute inset-y-0 right-0 flex items-center xl:static xl:inset-auto xl:ml-6 xl:pr-6">

				<div class="relative mx-2 flex flex-row gap-2 xl:gap-4 items-center">

					@if(!authService.isAuthenticated()){
						<peps-lang-selector [items]="itemsDropdownLang" class="hidden xl:block"></peps-lang-selector>
					} @else {
						<div class="flex flex-row gap-2 items-center border-2 border-peps-gold px-4 py-1 rounded-full bg-peps-dark-600">
							<img src="assets/images/pepscoins.png" alt="" class="w-4 h-4">
							<span class="text-xl">{{ authService.getCoins()}}</span>
						</div>
					}
					<button
						(click)="openDrawer()"
						(keydown.enter)="openDrawer()"
						class="relative rounded-full cursor-pointer p-2 bg-peps-gold block">
						<svg width="24" height="24" viewBox="0 0 24 27" fill="none" class="text-peps-orange">
							<path d="M20.5717 12.5359L17.1431 16.393H13.7146L10.7146 19.768V16.393H6.85742V1.92871H20.5717V12.5359Z" fill="white"/>
							<path d="M6.00056 0L1.71484 4.82143V22.1786H6.8577V27L11.1434 22.1786H14.572L22.2863 13.5V0H6.00056ZM20.572 12.5357L17.1434 16.3929H13.7148L10.7148 19.7679V16.3929H6.8577V1.92857H20.572V12.5357Z" fill="currentColor"/>
							<path d="M18.0014 5.30371H16.2871V11.0894H18.0014V5.30371Z" fill="currentColor"/>
							<path d="M13.2866 5.30371H11.5723V11.0894H13.2866V5.30371Z" fill="currentColor"/>
						</svg>
						@if (showLiveBadge()) {
							<span class="absolute -top-1.5 -right-1.5 min-w-5 h-5 px-1 bg-peps-red rounded-full text-white text-xs font-bold font-notosans flex items-center justify-center">
								{{ liveCount() }}
							</span>
						}
					</button>

					@if(!authService.isAuthenticated()){
						@if(isAuthEnabled) {
							<button
								*featureFlag="'AUTHENTICATION'"
								(click)="loginWithTwitch()"
								class="text-peps-dark-700 bg-peps-gold py-1 px-4 cursor-pointer hover:bg-peps-yellow transition-colors duration-300 hidden xl:block uppercase"
							>{{ 'component.navbar.login' | translate }}</button>
						}
					} @else {
						<peps-notification-center class="hidden xl:block"></peps-notification-center>
						<peps-navbar-profile-button
							class="hidden xl:block"
							[text]="authService.userInitial"
							[picture]="userPicture"
							[items]="itemsDropdownProfile"
						></peps-navbar-profile-button>
					}

				</div>
			</div>

		</div>

	</div>

	<div
		class="fixed w-full h-full inset-y-0 left-0 bg-peps-dark-700 z-100 xl:hidden transform transition-transform duration-300 ease-in-out -translate-x-full overflow-y-scroll overflow-x-hidden custom-scrollbar"
		[ngClass]="{'translate-x-0': isMobileMenuOpen}"
		id="mobile-menu"
	>
		<div class="flex flex-row justify-between items-center pr-6">

			<button
				type="button"
				class="relative inline-flex items-center justify-center rounded-md p-2 pt-4 ml-4 cursor-pointer"
				(click)="toggleMobileMenu()"
				(keydown.enter)="toggleMobileMenu()"
				aria-controls="mobile-menu" aria-expanded="false">
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-12">
					<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
				</svg>
			</button>
			<div class="flex gap-4 items-center flex-row">
				@if(!authService.isAuthenticated()){
					@if(isAuthEnabled) {
						<peps-lang-selector [items]="itemsDropdownLang"></peps-lang-selector>
						<button
							*featureFlag="'AUTHENTICATION'"
							(click)="loginWithTwitch()"
							class="text-peps-dark-700 bg-peps-gold py-1 px-4 cursor-pointer hover:bg-peps-yellow transition-colors duration-300 block xl:hidden uppercase"
						>{{ 'component.navbar.login' | translate }}</button>
					}
				} @else {
					<peps-notification-center></peps-notification-center>
					<peps-navbar-profile-button
						class="block xl:hidden"
						[text]="authService.userInitial"
						[picture]="userPicture"
						[items]="itemsDropdownProfile"
					></peps-navbar-profile-button>
				}
			</div>

		</div>
		<div class="flex flex-col gap-4 text-2xl px-12 py-16">
			<peps-dropdown-button
				[text]="'component.navbar.team.title' | translate"
				route="roster"
				[items]="itemsDropdownRoster"
				[isMobileNavbar]="true"
			></peps-dropdown-button>
			<peps-dropdown-button
				[text]="'component.navbar.club.title' | translate"
				route="club"
				[items]="itemsDropdownClub"
				[isMobileNavbar]="true"
			></peps-dropdown-button>
			<peps-button-simple
				[text]="'common.matches.titlecase' | translate"
				route="matchs"
				(click)="toMatches()"
				(keydown.enter)="toMatches()"
			></peps-button-simple>
			<peps-button-simple
				[text]="'component.navbar.ambassadors' | translate"
				route="ambassadors"
				(click)="toAmbassadors()"
				(keydown.enter)="toAmbassadors()"
			></peps-button-simple>
			<peps-button-simple
				[text]="'common.partners' | translate"
				route="partners"
				(click)="toPartners()"
				(keydown.enter)="toPartners()"
			></peps-button-simple>
			<peps-button-simple
				[text]="'common.support-us' | translate"
				(click)="toTipee()"
				(keydown.enter)="toTipee()"
			></peps-button-simple>
			<peps-category-dropdown-button
				[text]="'component.navbar.game.title' | translate"
				[items]="itemsDropdownGames"
				[isMobileNavbar]="true"
			></peps-category-dropdown-button>
			@if (showTicketing()) {
				<a
					[href]="ticketingUrl"
					target="_blank"
					rel="noopener noreferrer"
					class="inline-block text-center px-6 py-3 text-peps-dark-900 bg-peps-gold font-black uppercase tracking-wider"
				>
					{{ "component.navbar.ticketing" | translate }}
				</a>
			}
		</div>
	</div>

</nav>

<div class="z-100 fixed inset-0 bg-black/60 transition-opacity duration-300 ease-in-out"
     [class.opacity-0]="!isOpen()" [class.pointer-events-none]="!isOpen()"
     (click)="closeDrawer()" (keydown.enter)="closeDrawer()"
></div>

<div class="z-101 fixed top-0 right-0 w-full sm:w-3/5 lg:w-3/7 xl:w-2/6 2xl:w-2/8 h-full bg-peps-dark-700 border-x border-x-peps-dark-600 border-t-6 border-t-peps-gold p-4 md:p-8 flex flex-col gap-8 overflow-y-auto transition-transform duration-300 ease-in-out"
     [class.translate-x-full]="!isOpen()" [class.translate-x-0]="isOpen()"
>
	<div class="flex flex-row justify-between items-center">
		<div class="flex flex-col gap-1">
			<span class="uppercase text-peps-gold font-notosans">Team Peps</span>
			<span class="uppercase font-xtradex text-3xl">{{ 'component.navbar-twitch.live-channels' | translate }}</span>
		</div>
		<button class="border border-peps-dark-600 p-2 cursor-pointer" (click)="closeDrawer()" (keydown.enter)="closeDrawer()">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
				<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
			</svg>
		</button>
	</div>
	<div class="flex flex-col gap-6">
		<div class="flex flex-row justify-between items-center gap-3">
			<span class="py-1 px-2 bg-peps-gold text-peps-dark-800 uppercase">{{ streamersOnline().length + (mainStreamer()?.isLive ? 1 : 0) }} {{ 'component.navbar-twitch.online' | translate }}</span>
			<span class="flex-1 h-px bg-peps-dark-600"></span>
		</div>

		@if(mainStreamer()) {
			<a [href]="'https://twitch.tv/' + mainStreamer()!.pseudo" target="_blank" class="relative w-full  aspect-video border border-peps-dark-600 hover:border-peps-gold" [style.background-image]="'url(' + mainStreamer()!.thumbnailUrl + ')'" style="background-size: cover; background-position: center;">
				<span class="absolute top-4 left-4 bg-peps-red py-px px-2 flex flex-row items-center gap-1 text-xs sm:text-base"><span class="bg-white size-1.5 rounded-full"></span>LIVE</span>
				<span class="absolute top-4 right-4 bg-peps-dark-700 py-1 px-2.5 flex flex-row items-center gap-1 font-notosans text-sm">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
					  <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
					  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
					</svg>
					{{mainStreamer()!.viewerCount}}
				</span>

				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="invisible sm:visible size-16 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-peps-gold">
					<path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
					<path stroke-linecap="round" stroke-linejoin="round" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z" />
				</svg>

				<div class="absolute bottom-0 left-0 w-full py-4 px-4 flex flex-row justify-between items-end bg-linear-to-t from-peps-dark-900 to-transparent">
					<div class="flex flex-row items-end gap-4">
						<img [src]="mainStreamer()!.avatarUrl" class="size-16 rounded-full" />
						<div class="flex flex-col gap-1">
							<span class="font-xtradex text-xl md:text-3xl">{{mainStreamer()!.displayName}}</span>
							<span class="font-notosans text-xs text-peps-text-5">{{mainStreamer()!.gameName}}</span>
						</div>
					</div>
					<span class="font-notosans text-peps-gold font-bold flex flex-row gap-2">{{'component.navbar-twitch.watch' | translate }}
						<svg class="size-6" viewBox="0 0 24 24" fill="none"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
					</span>
				</div>

			</a>
		}

		<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
			@for(streamer of streamersOnline(); track streamer.pseudo) {
				<a target="_blank" [href]="'https://twitch.tv/' + streamer.pseudo" class="flex flex-col gap-2 border border-peps-dark-600 bg-peps-dark-800 p-3 hover:border-peps-gold cursor-pointer">
					<div class="flex flex-row gap-4 items-center">
						<img [src]="streamer.avatarUrl" class="size-12" />
						<a class="text-base cursor-pointer" target="_blank" [href]="'https://twitch.tv/' + streamer.pseudo">{{streamer.displayName}}</a>
					</div>
					<div class="flex flex-row justify-between items-end">
						<span class="font-notosans text-xs text-peps-text-5">{{streamer.gameName}}</span>
						<span class="font-notosans text-sm text-peps-gold font-semibold flex flex-row gap-1 items-center">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
							  <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
							  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
							</svg>
							{{streamer.viewerCount}}</span>
					</div>

				</a>
			}

		</div>

		<div class="flex flex-row justify-between items-center gap-3">
			<span class="font-notosans text-peps-dark-200 text-sm">{{ streamersOffline().length }} {{ 'component.navbar-twitch.offline' | translate }}</span>
			<span class="flex-1 h-px bg-peps-dark-600"></span>
		</div>
		<div class="grid grid-cols-2 md:grid-cols-3 gap-4">
			@for(streamer of streamersOffline(); track streamer.pseudo) {
				<a [href]="'https://twitch.tv/' + streamer.pseudo" target="_blank" class="group flex flex-col gap-2 items-center cursor-pointer border border-peps-dark-600 p-4 bg-peps-dark-800 hover:border-peps-gold">
					<span class="border-3 border-peps-gold rounded-full">
						<img [src]="streamer.avatarUrl" class="size-12 rounded-full grayscale-75 group-hover:grayscale-0 transition-all duration-200" />
					</span>
					<div class="flex flex-row items-center gap-1">
						<span class="text-sm">{{streamer.displayName}}</span>
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-3 text-peps-dark-200">
							<path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
						</svg>
					</div>
				</a>
			}

		</div>

	</div>

</div>

